<template lang="pug">
	.publisher-ai-settings(v-if="showed && publisher" v-window)
		.card(@click.stop)
			.card-header
				i.fa.fa-magic
				span {{publisher.title}} AI settings
				.publisher-id Publisher id: {{publisher.id}}
			.card-body.collapse.show
				.form-horizontal
					.form-group.budget.separator
						label Company AI budget: {{budget ? '$' + budget['ai_budget'].toFixed(2) : '...'}}
						.description.text-muted
							span Money available for the AI features of «{{publisher.title}}»
						.budget-added(v-if="isSuperAdmin && budget")
							span Total added to the company: ${{budget['ai_budget_spent'].toFixed(2)}}
							button.btn.btn-ghost-dark.btn-sm(type="button" @click="recalculateBudgetAdded()" v-b-tooltip.hover="{delay: {show: 500, hide: 100}, title: 'Recalculate from the AI budget log'}")
								i.fa.fa-refresh
					.form-group.budget-change.separator(v-if="isSuperAdmin")
						label Change company AI budget
						.description.text-muted
							span Super admins can add or remove AI budget from the company with a reason
						.form-line.budget
							InputSelect(:key="`budget-amount-${budgetInputKey}`" v-on:change="setBudgetAmount($event)" :default="0" :value="amount" :values="counts" :options="{dropdownWidth: 80}" type="number" theme="dark-medium")
							input.form-control.form-control-sm.reason(type="text" v-model="reason" placeholder="Reason" maxlength="300")
						.form-line.budget-buttons
							button.btn.btn-primary.btn-sm(type="button" :disabled="!canChangeBudget()" @click="addBudget()")
								i.fa.fa-plus
								span Add AI budget
							button.btn.btn-danger.btn-sm(type="button" :disabled="!canChangeBudget()" @click="removeBudget()")
								i.fa.fa-minus
								span Remove AI budget
					.form-group.budget-split.separator(v-if="isPublisherAdmin && budget")
						label Creatives and users AI budgets
						.description.text-muted
							span(v-if="budget['ai_budget_split']") AI spends the budget of the user first and then the budget of the creative. The company budget can be transferred to creatives and users.
							span(v-else) AI spends the company budget directly. Creatives and users AI budgets are not used.
						div
							button.btn.btn-sm(type="button" :class="{'btn-primary': !budget['ai_budget_split'], 'btn-outline-danger': budget['ai_budget_split']}" @click="setBudgetSplit(!budget['ai_budget_split'])")
								span(v-if="budget['ai_budget_split']") Disable creatives and users AI budgets
								span(v-else) Enable creatives and users AI budgets
					.form-group.budget-log.separator
						label AI budget additions
						.description.text-muted
							span When and who added money to the company AI budget
						.budget-log-records(v-if="log.length" key="budget-log-records" v-bar :style="{height: `${Math.min(log.length, MAX_VISIBLE_LOG_RECORDS) * LOG_RECORD_HEIGHT}px`}")
							.budget-log-records-inner
								.budget-log-record(v-for="record in log" :key="record.id" :style="{height: `${LOG_RECORD_HEIGHT}px`}")
									.date {{formatDate(record.date)}}
									.amount(:class="{negative: record.amount < 0}") {{record.amount < 0 ? '-' : '+'}}${{Math.abs(record.amount).toFixed(2)}}
									.user {{record.userName || 'System'}}
									.reason(:title="record.reason") {{record.reason}}
						.empty-log(v-else key="empty-log") There are no AI budget additions yet
					.form-actions
						button.btn.btn-dark(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen'

	import { Publisher } 		from '../../services/Publisher'
	import { User } 			from '../../services/User'

	import InputSelect			from './../Editor/Controls/InputSelect'

	export default {
		name: "PublisherSettingsAI",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Publisher AI Budget Changed",
				"Selected Publisher Changed"
			],
			events: {
			}
		},
		components: {
			InputSelect
		},
		data() {

			this.Publisher = Publisher;
			this.User = User;

			// Сколько записей списка добавлений бюджета видно без прокрутки и высота одной записи
			this.MAX_VISIBLE_LOG_RECORDS = 7;
			this.LOG_RECORD_HEIGHT = 32;

			this.counts = [
				{title: '$1', data: {itemValue: 1}},
				{title: '$5', data: {itemValue: 5}},
				{title: '$15', data: {itemValue: 15}},
				{title: '$50', data: {itemValue: 50}},
				{title: '$150', data: {itemValue: 150}}
			];

			this.log = [];

			return {
				amount: 0,
				reason: '',
				// Смена ключа пересоздаёт поле ввода суммы - так оно очищается (InputSelect хранит введённое значение у себя)
				budgetInputKey: 0
			}
		},
		methods: {
			collectData(eventName) {

				this.publisher = Publisher.SelectedPublisher;

				if (!this.publisher) return;

				this.isSuperAdmin = !!User.currentUser.Tags['super-admin'];
				this.isPublisherAdmin = Publisher.isPublisherAdmin(this.publisher.id);
				this.budget = Publisher.AIBudgets[this.publisher.id];
				this.log = Publisher.AIBudgetLogs[this.publisher.id] || [];

				// Бюджет и список добавлений денег паблишеру загружаем при открытии окна и при смене паблишера
				if (eventName === 'show' || eventName === 'Selected Publisher Changed') {

					Server.sendToServer({
						GetPublisherAI: {
							publisherId: this.publisher.id
						}
					});

				}

			},
			setBudgetAmount(amount) {

				this.amount = amount;

			},
			canChangeBudget() {

				return this.amount > 0 && this.reason.trim().length > 0;

			},
			addBudget() {

				Server.sendToServer({
					AddPublisherAIBudget: {
						publisherId: this.publisher.id,
						amount: this.amount,
						reason: this.reason.trim()
					}
				});

				this.clearBudgetChange();

			},
			removeBudget() {

				Server.sendToServer({
					RemovePublisherAIBudget: {
						publisherId: this.publisher.id,
						amount: this.amount,
						reason: this.reason.trim()
					}
				});

				this.clearBudgetChange();

			},
			// После добавления / отнимания бюджета очищаем сумму и причину
			clearBudgetChange() {

				this.amount = 0;
				this.reason = '';
				this.budgetInputKey++;

			},
			recalculateBudgetAdded() {

				Server.sendToServer({
					RecalculatePublisherAIBudgetAdded: {
						publisherId: this.publisher.id
					}
				});

			},
			setBudgetSplit(enabled) {

				Server.sendToServer({
					SetPublisherAIBudgetSplit: {
						publisherId: this.publisher.id,
						enabled: !!enabled
					}
				});

			},
			formatDate(date) {

				return new Date(date).toLocaleString();

			}
		}
	}
</script>


<style lang="sass">

	.publisher-ai-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.publisher-id
			position: absolute
			top: 19px
			right: 19px
			opacity: 0.1

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 750px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			.btn-ghost-dark, .btn-dark
				color: #fff

			.form-actions .btn-dark
				float: right

		.form-line
			display: flex
			flex-direction: row
			align-items: center

		.form-group
			display: flex
			flex-direction: column

			> .description
				margin-bottom: 10px

		.budget-added
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 10px

			.btn
				margin-left: 10px

		.form-line.budget
			margin-bottom: 10px

			.input-select-control
				margin-right: 20px

				input
					width: 80px

			.reason
				width: 300px

		.form-line.budget-buttons

			.btn-primary
				margin-right: 20px

			.fa
				margin-right: 7px

		.budget-log-records
			position: relative
			overflow: hidden

			.budget-log-records-inner

				&::-webkit-scrollbar
					width: 4px
				&::-webkit-scrollbar-thumb
					background-color: #3f454b
					border-radius: 10px
				&::-webkit-scrollbar-track
					background-color: #ADB6BF66

			.vb-dragger
				.vb-dragger-styler
					background-color: rgba(255, 255, 255, 0.2)

				&:hover .vb-dragger-styler
					background-color: rgba(255, 255, 255, 0.4)

			.budget-log-record
				display: flex
				flex-direction: row
				align-items: center
				white-space: nowrap

				.date
					width: 170px

				.amount
					width: 90px
					color: #4dbd74

					&.negative
						color: var(--red)

				.user
					width: 150px
					overflow: hidden
					text-overflow: ellipsis

				.reason
					flex: 1
					overflow: hidden
					text-overflow: ellipsis
					margin-right: 10px

		.form-actions
			margin-top: 20px

	.publisher-ai-settings.hiding
		opacity: 0

		.card
			transform: scale(0.9)

</style>
